import { Component, OnInit } from '@angular/core';
import {
  MatchResult,
  MatchResults,
  StatsService,
} from '../../service/stats.service';
import { SoundFile } from '../../utils/utils';
import { Howl } from 'howler';
import { PzService } from '../../service/pz.service';
import { GENERAL_ERROR_SUMMARY } from '../../utils/error-handler';
import { NotificationService } from '../../service/notification.service';

enum Player {
  Player1 = 'Player1',
  Player2 = 'Player2',
}

interface Crown {
  player: Player;
  crownIndex: number;
}

@Component({
  selector: 'app-crowns',
  templateUrl: './crowns.component.html',
})
export class CrownsComponent implements OnInit {
  public displayCrownsPlayer1 = [];
  public displayCrownsPlayer2 = [];
  public allCrowns: Crown[] = [];

  private assetsDir = 'assets/mp3/';

  private soundWin = new Howl({
    src: [`${this.assetsDir}/${SoundFile.DING}`],
    html5: true,
  });

  constructor(
    private statsService: StatsService,
    private pzService: PzService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    const timerMs = 500;

    setTimeout(() => {
      this.statsService.getStats().subscribe({
        next: (data: MatchResults) => {
          console.log('Match results: ', data);
          this.computeResults(data);
          this.allCrowns.forEach((item: Crown, index) => {
            setTimeout(() => {
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              item.player === Player.Player1
                ? (this.displayCrownsPlayer1[item.crownIndex] = 1)
                : (this.displayCrownsPlayer2[item.crownIndex] = 1);
              this.playSound();
            }, timerMs * index);
          });
        },
        error: (e) => {
          console.error('error', e);
          this.notificationService.showError(GENERAL_ERROR_SUMMARY, e.message);
        },
      });
    }, timerMs); // Short break for loading player images
  }

  playSound(): void {
    if (this.pzService.soundOn) {
      this.soundWin.play();
    }
  }

  computeResults(data: MatchResults): void {
    let crownsNumPlayer1 = 0;
    let crownsNumPlayer2 = 0;

    const crownsPlayer1: Crown[] = [];
    const crownsPlayer2: Crown[] = [];

    data.matches.forEach((matchItem: MatchResult) => {
      if (matchItem.player1 > matchItem.player2) {
        crownsPlayer1.push({
          player: Player.Player1,
          crownIndex: crownsNumPlayer1++,
        });
      } else if (matchItem.player2 > matchItem.player1) {
        crownsPlayer2.push({
          player: Player.Player2,
          crownIndex: crownsNumPlayer2++,
        });
      } else {
        crownsPlayer1.push({
          player: Player.Player1,
          crownIndex: crownsNumPlayer1++,
        });
        crownsPlayer2.push({
          player: Player.Player2,
          crownIndex: crownsNumPlayer2++,
        });
      }
    });
    this.allCrowns = crownsPlayer1.concat(crownsPlayer2);
  }

  getPlayer1Class(index: number): string {
    return `crown-player1-${index + 1}`;
  }

  getPlayer2Class(index: number): string {
    return `crown-player2-${index + 1}`;
  }
}
